import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { useObserver } from 'mobx-react-lite';
import moment from 'moment-timezone';
import React from 'react';
import EnhancedTableHead, { getSorting, HeadRow, Order, sortRows } from '../../common/EnhancedTableHead';
import LinkRouter from '../../common/LinkRouter';
import TimestampTooltip from '../../common/TimestampTooltip';

interface Props {
  deployments: any[];
  accountId: string;
  region: string;
  page: number;
  onPageChange: (newPage: number) => void;
}

const headRows: HeadRow[] = [
  { id: 'name', disablePadding: true, label: 'Name' },
  { id: 'lastModified', disablePadding: false, label: 'Last Modified' },
  { id: 'deploymentState', disablePadding: false, label: 'Deployment State' },
  { id: 'global', disablePadding: false, label: 'Global' }
];

function FaroDeploymentsTable(props: Props) {
  const { deployments, accountId, region, page, onPageChange } = props;
  const [order, setOrder] = React.useState<Order>('desc');
  const [orderBy, setOrderBy] = React.useState<string>('lastModified');
  const [rowsPerPage, setRowsPerPage] = React.useState(20);

  function handleRequestSort(event: React.MouseEvent<unknown>, property: string) {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    onPageChange(0);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    onPageChange(newPage);
  };

  const sortedRows = sortRows(deployments, getSorting(order, orderBy));

  return useObserver(() => (
    <div>
      <Table>
        <EnhancedTableHead
          order={order}
          orderBy={orderBy}
          fields={headRows}
          onRequestSort={handleRequestSort}
        />
        <TableBody>
          {sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => (
            <TableRow key={`${row.name}::${row.global}`}>
              <TableCell>
                <LinkRouter to={`/faro/deployments/${accountId}/${region}/${row.name}?global=${row.global}`}>{row.name}</LinkRouter>
              </TableCell>
              <TableCell>
                <TimestampTooltip timestamp={row.lastModified}>
                  <div>{moment(row.lastModified).fromNow()}</div>
                </TimestampTooltip>
              </TableCell>
              <TableCell>{row.deploymentState}</TableCell>
              <TableCell>{row.global ? 'Yes' : 'No'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[10, 20, 50]}
        component="div"
        count={deployments.length}
        rowsPerPage={rowsPerPage}
        page={page}
        backIconButtonProps={{
          'aria-label': 'previous page',
        }}
        nextIconButtonProps={{
          'aria-label': 'next page',
        }}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </div>
  ));
};

export default FaroDeploymentsTable;
